import React from 'react';
import './Logo.scss';

export const Logo = ({ animate = false }) => {
  return (
    <div className={`plab-logo ${animate ? 'animate' : ''}`}>
      <div className="logo-icon-container">
        <svg
          viewBox="0 0 120 120"
          className="logo-svg"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Stethoscope tubing — wraps around the microphone */}
          <path
            className="steth-tube"
            d="M 38 18 C 14 18, 8 42, 8 58 C 8 82, 24 100, 48 100 L 72 100 C 96 100, 112 82, 112 58 C 112 42, 106 18, 82 18"
            fill="none"
            stroke="url(#tubeGrad)"
            strokeWidth="3.5"
            strokeLinecap="round"
          />

          {/* Stethoscope earpieces (top left & right) */}
          <circle className="steth-ear steth-ear-l" cx="38" cy="16" r="4" fill="#5b9bd5" />
          <circle className="steth-ear steth-ear-r" cx="82" cy="16" r="4" fill="#5b9bd5" />

          {/* Y-connector at top */}
          <line x1="38" y1="18" x2="60" y2="30" stroke="#5b9bd5" strokeWidth="2.5" strokeLinecap="round" className="steth-y" />
          <line x1="82" y1="18" x2="60" y2="30" stroke="#5b9bd5" strokeWidth="2.5" strokeLinecap="round" className="steth-y" />

          {/* Chest piece at the bottom of the stethoscope */}
          <circle className="steth-chest" cx="60" cy="104" r="8" fill="url(#chestGrad)" stroke="#4a8ec9" strokeWidth="1.5" />
          <circle cx="60" cy="104" r="4" fill="#e8f0fe" opacity="0.6" />

          {/* ── Microphone ── */}
          {/* Mic body (capsule) */}
          <rect className="mic-body" x="52" y="36" width="16" height="28" rx="8" fill="url(#micGrad)" />
          {/* Mic grille lines */}
          <line x1="55" y1="43" x2="65" y2="43" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
          <line x1="55" y1="47" x2="65" y2="47" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
          <line x1="55" y1="51" x2="65" y2="51" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
          <line x1="55" y1="55" x2="65" y2="55" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />

          {/* Mic cradle (U-shape holder) */}
          <path
            className="mic-cradle"
            d="M 48 52 C 48 72, 60 78, 60 78 C 60 78, 72 72, 72 52"
            fill="none"
            stroke="#5b9bd5"
            strokeWidth="2.5"
            strokeLinecap="round"
          />

          {/* Mic stem */}
          <line className="mic-stem" x1="60" y1="78" x2="60" y2="90" stroke="#5b9bd5" strokeWidth="2.5" strokeLinecap="round" />

          {/* Mic base */}
          <ellipse className="mic-base" cx="60" cy="91" rx="10" ry="3" fill="#5b9bd5" opacity="0.7" />

          {/* Pulse rings (animate only) */}
          <circle className="pulse-ring pulse-ring-1" cx="60" cy="50" r="18" fill="none" stroke="#5b9bd5" strokeWidth="1" opacity="0" />
          <circle className="pulse-ring pulse-ring-2" cx="60" cy="50" r="18" fill="none" stroke="#5b9bd5" strokeWidth="1" opacity="0" />

          {/* Gradients */}
          <defs>
            <linearGradient id="tubeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#5b9bd5" />
              <stop offset="50%" stopColor="#3a7ec8" />
              <stop offset="100%" stopColor="#5b9bd5" />
            </linearGradient>
            <linearGradient id="micGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#4a8ec9" />
              <stop offset="100%" stopColor="#2B4C7E" />
            </linearGradient>
            <radialGradient id="chestGrad" cx="50%" cy="40%" r="60%">
              <stop offset="0%" stopColor="#7ab8e8" />
              <stop offset="100%" stopColor="#3a7ec8" />
            </radialGradient>
          </defs>
        </svg>
      </div>
      <span className="text">SimplePLAB<sup>2</sup></span>
    </div>
  );
};